/*
  PawsLife Konfigurator-Insights
  ------------------------------
  Ein gemeinsames Datenmodell fuer BEIDE Konfiguratoren (eigener Wizard und
  TeeInBlue), damit sich Produkte mit unterschiedlich vielen Schritten in GA4
  vergleichen lassen. Alle Ereignisse gehen ausschliesslich in den dataLayer -
  ob und wann daraus ein GA4-Treffer wird, entscheidet der Google Tag Manager
  (inkl. Consent Mode).

  Bewusst NICHT erfasst: Freitexte (Tiernamen, Daten, Gravuren) und Dateinamen.
  Von Texteingaben wird nur gemeldet, DASS sie ausgefuellt wurden.
*/
(function () {
  'use strict';

  if (window.pawsInsights && window.pawsInsights.ready) return;

  var ctxEl = document.querySelector('script[type="application/json"][data-paws-track]');
  var ctx = {};
  try { ctx = ctxEl ? JSON.parse(ctxEl.textContent) : {}; } catch (e) { ctx = {}; }
  ctx.configurator = ctx.isTib ? 'teeinblue' : 'paws';

  window.dataLayer = window.dataLayer || [];

  var startZeit = 0;
  var sessionId = 'cfg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  var gesendet = Object.create(null);
  var letzterWert = { preis: null };
  var engageGesendet = false;
  var bekannteSchluessel = Object.create(null);

  // Ereignisse, die eine bewusste Handlung belegen. Das erste davon loest
  // 'configurator_engage' aus. 'configurator_start' feuert dagegen schon beim
  // Aufbau der Seite und taugt deshalb nicht als Mass fuer echte Konfiguration.
  var INTERAKTION = {
    configurator_option: 1,
    configurator_photo_start: 1,
    configurator_step_next: 1,
    configurator_step_back: 1,
    configurator_upsell: 1,
    configurator_add_to_cart: 1
  };

  // Der Tag Manager buendelt alles aus einem Tick zu einem Paket; die Treffer
  // bekommen dann denselben Zeitstempel und GA4 sortiert sie im Trichter
  // zufaellig (Symptom: Schritt 2 ueber 100 %). Automatisch vorangestellte
  // Ereignisse brauchen deshalb Abstand zum ausloesenden Ereignis.
  var VORLAUF_ABSTAND = 150;

  // Nach diesen Ereignissen kann die Seite sofort wechseln - nichts verzoegern.
  var SOFORT = {
    configurator_add_to_cart: 1,
    configurator_add_to_cart_success: 1,
    configurator_checkout_redirect: 1,
    configurator_error: 1
  };

  function zahl(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) ? n : null;
  }

  // A/B-Test des eigenen Konfigurators (A = Schritt fuer Schritt, B = Single Page).
  // Die Zuweisung setzt layout/theme.liquid im <head>, hier wird sie nur gelesen.
  // TeeInBlue nimmt am Test nicht teil und bekommt den Parameter deshalb nicht -
  // sonst waeren die Berichte mit einer Gruppe verunreinigt, die die Variante
  // nie zu sehen bekommen hat.
  function abVariante() {
    if (ctx.isTib) return undefined;
    var v = window.PAWS_AB;
    return (v === 'A' || v === 'B') ? v : undefined;
  }

  // Ueber ?paws_ab= erzwungene Aufrufe sind Team- und QA-Traffic. Sie bleiben
  // im Bericht, muessen sich aber herausfiltern lassen - sonst entscheidet ein
  // Abstimmungstermin ueber den Testausgang.
  function abErzwungen() {
    if (ctx.isTib) return undefined;
    return abVariante() ? (window.PAWS_AB_FORCED ? '1' : '0') : undefined;
  }

  // Solange ein Vorlauf laeuft, wandern alle weiteren Meldungen in die
  // Warteschlange - sonst ueberholt z.B. der Schrittwechsel den Weiter-Klick.
  var stau = [];
  var stauTimer = null;

  function stauLeeren() {
    if (stauTimer) { clearTimeout(stauTimer); stauTimer = null; }
    var liste = stau;
    stau = [];
    for (var i = 0; i < liste.length; i++) senden(liste[i][0], liste[i][1]);
  }

  function stauPlanen() {
    if (stauTimer) return;
    stauTimer = setTimeout(function () { stauTimer = null; stauLeeren(); }, VORLAUF_ABSTAND);
  }

  function track(name, payload) {
    try {
      if (!name) return;
      payload = payload || {};

      var vorlauf = false;
      if (!startZeit && name !== 'configurator_start') {
        startInterakt(payload.configurator);
        vorlauf = true;
      }
      if (!engageGesendet && INTERAKTION[name]) {
        engageGesendet = true;
        var erstkontakt = { configurator: payload.configurator, trigger_event: name };
        ['step_index', 'step_total', 'step_id', 'step_name'].forEach(function (k) {
          if (payload[k] !== undefined && payload[k] !== null) erstkontakt[k] = payload[k];
        });
        senden('configurator_engage', erstkontakt);
        vorlauf = true;
      }
      if (vorlauf) stauPlanen();

      if (SOFORT[name]) { stauLeeren(); senden(name, payload); return; }
      if (stauTimer) { stau.push([name, payload]); return; }
      senden(name, payload);
    } catch (e) {
      /* Tracking darf den Konfigurator niemals stoppen. */
    }
  }

  // Verlaesst der Besucher die Seite, darf nichts in der Warteschlange bleiben.
  window.addEventListener('pagehide', function () { try { stauLeeren(); } catch (e) {} });

  function senden(name, payload) {
    try {
      payload = payload || {};
      if (payload.value !== undefined && payload.value !== null) letzterWert.preis = zahl(payload.value);

      // Der Basisblock haengt an JEDEM Ereignis - jedes Feld hier kostet einen
      // der 25 GA4-Parameter auf allen Ereignissen gleichzeitig. Neue Parameter
      // gehoeren deshalb in die Nutzlast des track()-Aufrufs, nicht hierher.
      var daten = {
        event: name,
        configurator_session: sessionId,
        configurator: payload.configurator || ctx.configurator || 'unbekannt',
        ab_variant: abVariante(),
        ab_forced: abErzwungen(),
        product_handle: ctx.productHandle || null,
        product_type: ctx.productType || null,
        currency: ctx.currency || 'EUR',
        value: payload.value !== undefined && payload.value !== null ? zahl(payload.value) : letzterWert.preis,
        seconds_since_start: startZeit ? Math.round((Date.now() - startZeit) / 100) / 10 : 0
      };

      for (var k in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, k) && k !== 'configurator') daten[k] = payload[k];
      }
      if (daten.step_index && daten.step_total) {
        daten.progress_pct = Math.round((daten.step_index / daten.step_total) * 100);
      }
      // Beide sind in GA4 als Definition nicht registriert und ohne BigQuery-Export
      // nirgends auswertbar: step_total dient nur der Rechnung darueber, die
      // gekaufte Variante liefert Shopifys eigenes purchase als item_variant.
      daten.step_total = undefined;
      daten.variant_id = undefined;
      // Der Tag Manager fuehrt aufeinanderfolgende Pushes zusammen: ein einmal
      // gesetzter Parameter haengt sonst an allen spaeteren Ereignissen
      // (z.B. resume_action an jedem folgenden Schrittwechsel).
      for (var alt in bekannteSchluessel) {
        if (!(alt in daten)) daten[alt] = undefined;
      }
      for (var neu in daten) bekannteSchluessel[neu] = 1;
      // GA4 verwirft ab dem 26. Parameter still und ohne Fehlermeldung, und
      // welche es trifft, ist nicht zugesichert. Lieber hier laut werden.
      if (window.console) {
        var anzahl = 0;
        for (var p in daten) {
          if (p !== 'event' && daten[p] !== undefined && daten[p] !== null) anzahl++;
        }
        if (anzahl > 22) console.warn('[paws] Parameterbudget ' + name + ': ' + anzahl + '/25');
      }
      window.dataLayer.push(daten);
      // Liegt die Konfiguration im Warenkorb, gibt es nichts mehr fortzusetzen.
      if (name === 'configurator_add_to_cart_success' && window.pawsResume) window.pawsResume.fertig();
    } catch (e) {
      /* Tracking darf den Konfigurator niemals stoppen. */
    }
  }

  // Nur beim ersten Mal: markiert, dass der Konfigurator einsatzbereit ist.
  function startInterakt(quelle) {
    if (startZeit) return;
    startZeit = Date.now();
    senden('configurator_start', { configurator: quelle });
  }

  // Verhindert Doppelmeldungen (z.B. Schritt zweimal eingeblendet).
  function einmal(schluessel, name, payload) {
    if (gesendet[schluessel]) return;
    gesendet[schluessel] = true;
    track(name, payload);
  }

  window.pawsInsights = {
    ready: true,
    context: ctx,
    track: track,
    trackOnce: einmal,
    start: startInterakt,
    sessionId: sessionId,
    // Von assets/paws-resume.js genutzt, damit die Schritterkennung nur einmal existiert.
    tibSchritte: function () {
      return tibSchritte.map(function (s, i) { return { index: i + 1, name: s.name, el: s.el }; });
    },
    tibSchrittZu: function (el) { return tibSchrittZu(el); }
  };

  // Aufrufe, die vor dem Laden dieser Datei entstanden sind, nachholen.
  try {
    var q = window.pawsInsightsQueue;
    if (q && q.length) {
      q.forEach(function (eintrag) { track(eintrag[0], eintrag[1]); });
      window.pawsInsightsQueue = [];
    }
  } catch (e) {}

  /* ------------------------------------------------------------------
     TeeInBlue: Schritte erkennen, Interaktionen und Warenkorb melden
     ------------------------------------------------------------------ */
  var tibForm = null;
  var tibSchritte = [];

  function sichtbar(el) {
    return !!(el && el.getClientRects().length && el.offsetParent !== null);
  }

  function text(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) : '';
  }

  // TeeInBlue haengt die Pflichtfeld-Meldung in die Ueberschrift - die gehoert
  // nicht in den Schrittnamen, sonst heisst der Schritt nach dem ersten
  // Fehlversuch anders als davor.
  function ueberschrift(el) {
    if (!el) return '';
    try {
      var klon = el.cloneNode(true);
      Array.prototype.forEach.call(klon.querySelectorAll('.tee-required-message, .tee-error__message'), function (m) {
        m.parentNode.removeChild(m);
      });
      return text(klon);
    } catch (e) { return text(el); }
  }

  // Die Schrittnummern von TeeInBlue kommen aus dem CSS-Counter "tibStep" -
  // deshalb den BERECHNETEN Stil fragen statt die Regeln nachzubauen.
  function istSchrittUeberschrift(el) {
    try {
      var ci = window.getComputedStyle(el).counterIncrement || '';
      return ci.indexOf('tibStep') !== -1;
    } catch (e) { return false; }
  }

  function tibSchritteLesen() {
    if (!tibForm) return [];
    var kandidaten = tibForm.querySelectorAll('.tee-option__title, .tee-field__heading');
    var liste = [];
    Array.prototype.forEach.call(kandidaten, function (el) {
      if (!sichtbar(el) || !istSchrittUeberschrift(el)) return;
      var box = el.closest('.tee-option, .tee-field') || el;
      liste.push({ name: ueberschrift(el), el: box });
    });
    return liste;
  }

  function tibSchrittZu(el) {
    var box = el && el.closest ? el.closest('.tee-option, .tee-field') : null;
    for (var i = 0; i < tibSchritte.length; i++) {
      if (tibSchritte[i].el === box || (box && tibSchritte[i].el.contains(box))) {
        return { index: i + 1, name: tibSchritte[i].name };
      }
    }
    return { index: null, name: box ? ueberschrift(box.querySelector('.tee-field__heading, .tee-option__title')) : '' };
  }

  function tibBeobachten() {
    var neu = tibSchritteLesen();
    if (neu.length === tibSchritte.length && neu.every(function (s, i) { return tibSchritte[i] && tibSchritte[i].el === s.el; })) return;
    tibSchritte = neu;
    tibSichtPruefen();
  }

  // Bewusst kein IntersectionObserver: TeeInBlue baut die Felder waehrend der
  // Konfiguration mehrfach neu auf, wodurch Beobachtungen verloren gingen und
  // einzelne Schritte nie gemeldet wurden.
  function tibSichtPruefen() {
    if (!tibSchritte.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var oben = vh * 0.05;
    var unten = vh * 0.75;
    for (var i = 0; i < tibSchritte.length; i++) {
      var el = tibSchritte[i].el;
      if (!el || !el.getBoundingClientRect) continue;
      var r = el.getBoundingClientRect();
      if (!r.height) continue;
      if (r.top < unten && r.bottom > oben) {
        einmal('tib-view-' + (i + 1), 'configurator_step_view', {
          configurator: 'teeinblue',
          step_index: i + 1,
          step_total: tibSchritte.length,
          step_id: 'tib_' + (i + 1),
          step_name: tibSchritte[i].name
        });
      }
    }
  }

  var tibSichtTimer = null;
  function tibSichtAnstossen() {
    if (tibSichtTimer) return;
    tibSichtTimer = setTimeout(function () {
      tibSichtTimer = null;
      try { tibSichtPruefen(); } catch (e) {}
    }, 120);
  }

  function tibWert(ziel) {
    if (!ziel) return '';
    if (ziel.type === 'checkbox') return ziel.checked ? 'an' : 'aus';
    // Fotofelder: das umgebende Label enthaelt waehrend des Uploads die
    // Fortschrittsanzeige. Ohne Sonderfall landet "37 %" als Optionswert im
    // Bericht - und zwar mehrfach je Upload. Den Verlauf melden stattdessen
    // die configurator_photo_*-Ereignisse aus assets/tib-photo-upload.js.
    if (ziel.tagName === 'INPUT' && (ziel.type || '') === 'file') {
      return ziel.files && ziel.files.length ? 'foto gewaehlt' : 'leer';
    }
    // Freitexte werden nicht uebertragen - nur der Umstand, dass etwas drinsteht.
    if (ziel.tagName === 'TEXTAREA' || (ziel.tagName === 'INPUT' && /^(text|email|tel|number|date)$/.test(ziel.type || ''))) {
      return ziel.value && ziel.value.trim() ? 'ausgefuellt' : 'leer';
    }
    if (ziel.tagName === 'SELECT') {
      return ziel.selectedOptions && ziel.selectedOptions[0] ? text(ziel.selectedOptions[0]) : '';
    }
    var label = ziel.closest ? ziel.closest('label') : null;
    // Manche Felder stellen das Label als Geschwister mit for-Bezug daneben.
    if (!label && ziel.id) {
      try { label = document.querySelector('label[for="' + ziel.id.replace(/"/g, '\\"') + '"]'); } catch (e) { label = null; }
    }
    var beschriftung = text(label);
    if (!beschriftung && ziel.parentElement) {
      var bild = ziel.parentElement.querySelector('img[alt]');
      beschriftung = text(ziel.parentElement.querySelector('.tee-clipart-label')) || (bild ? bild.alt : '');
    }
    var wert = ziel.value || '';
    // Cliparts liefern Bildpfade - die sagen im Bericht nichts aus.
    if (/^https?:|\.(png|jpe?g|svg|webp)/i.test(wert)) wert = '';
    return (beschriftung || wert).slice(0, 60);
  }

  // TeeInBlue setzt Kachel- und Radioauswahlen per Skript: das Feld wird
  // angehakt, ein change-Ereignis gibt es dabei NICHT. Nur Textfelder und
  // Auswahllisten melden sich von selbst - deshalb zusaetzlich auf Klicks
  // hoeren und Doppelmeldungen ueber den zuletzt gemeldeten Wert abfangen.
  var tibWahlSpeicher = new WeakMap();

  function tibOption(ziel) {
    if (!ziel || !ziel.tagName) return;
    var wert = tibWert(ziel);
    var gruppe = (ziel.closest && ziel.closest('[role="radiogroup"], .tee-field__input, .tee-field, .tee-option')) || ziel;
    if (tibWahlSpeicher.get(gruppe) === wert) return;
    tibWahlSpeicher.set(gruppe, wert);

    startInterakt('teeinblue');
    var pos = tibSchrittZu(ziel);
    track('configurator_option', {
      configurator: 'teeinblue',
      step_index: pos.index,
      step_total: tibSchritte.length || null,
      step_id: pos.index ? 'tib_' + pos.index : 'tib_sonstiges',
      step_name: pos.name,
      option_name: pos.name,
      option_value: wert,
      input_type: (ziel.tagName === 'SELECT' ? 'select' : (ziel.type || ziel.tagName.toLowerCase()))
    });
    try { if (window.pawsResume && window.pawsResume.notiz) window.pawsResume.notiz(ziel); } catch (e) {}
  }

  function tibEingabeZuKlick(el) {
    if (!el || !el.closest) return null;
    if (el.tagName === 'INPUT' && /^(radio|checkbox)$/.test(el.type || '')) return el;
    var label = el.closest('label');
    if (!label) return null;
    var feld = label.control ||
      (label.htmlFor ? document.getElementById(label.htmlFor) : null) ||
      label.querySelector('input[type="radio"], input[type="checkbox"]');
    return feld && /^(radio|checkbox)$/.test(feld.type || '') ? feld : null;
  }

  function tibStart() {
    tibForm = document.getElementById('teeinblue-form');
    if (!tibForm) return false;

    tibForm.addEventListener('change', function (e) {
      tibOption(e.target);
    }, true);

    tibForm.addEventListener('click', function (e) {
      var feld = tibEingabeZuKlick(e.target);
      if (!feld) return;
      // TeeInBlue uebernimmt die Auswahl erst nach dem Klick.
      setTimeout(function () { try { tibOption(feld); } catch (err) {} }, 150);
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('#teeFormActions button, #teeFormActions [type="submit"]') : null;
      if (!btn) return;
      track('configurator_add_to_cart', {
        configurator: 'teeinblue',
        step_index: tibSchritte.length || null,
        step_total: tibSchritte.length || null,
        step_id: 'tib_atc',
        step_name: 'In den Warenkorb',
        // Gesetzt von assets/tib-checkout.js; ohne dieses bleibt der
        // Parameter leer statt falsch.
        kauf_weg: window.PAWS_TIB_KAUFWEG || undefined,
        upsell_count: 0
      });
      // TeeInBlue prueft erst nach dem Klick. Erfolg meldet tib-checkout.js
      // aus der bestaetigten Cart-Antwort; hier bleiben nur Pflichtfeldfehler.
      setTimeout(function () {
        var meldungen = document.querySelectorAll('#teeinblue-form .tee-required-message, #teeinblue-form .tee-error__message');
        var offen = [];
        Array.prototype.forEach.call(meldungen, function (m) {
          if (!sichtbar(m)) return;
          var feld = m.closest('.tee-field, .tee-option');
          var name = feld ? ueberschrift(feld.querySelector('.tee-field__heading, .tee-option__title')) : '';
          if (name && offen.indexOf(name) === -1) offen.push(name);
        });
        if (!meldungen.length || !offen.length) return;
        track('configurator_blocked', {
          configurator: 'teeinblue',
          step_index: tibSchritte.length || null,
          step_total: tibSchritte.length || null,
          step_id: 'tib_atc',
          step_name: 'In den Warenkorb',
          reason: 'pflichtfelder',
          missing_count: offen.length,
          missing_fields: offen.join(', ').slice(0, 120)
        });
      }, 600);
    }, true);

    tibBeobachten();
    window.addEventListener('scroll', tibSichtAnstossen, { passive: true });
    window.addEventListener('resize', tibSichtAnstossen, { passive: true });
    return true;
  }

  /* ------------------------------------------------------------------
     TeeInBlue: Varianten-ID in der Adresszeile mitfuehren
     ------------------------------------------------------------------ */
  var letzteUrlId = null;

  function urlVarianteSchreiben(id) {
    try {
      if (!id || !/^\d+$/.test(String(id))) return;
      if (String(id) === letzteUrlId) return;
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') === String(id)) { letzteUrlId = String(id); return; }
      url.searchParams.set('variant', String(id));
      window.history.replaceState(window.history.state, '', url.toString());
      letzteUrlId = String(id);
    } catch (e) {}
  }
  window.pawsInsights.syncVariantUrl = urlVarianteSchreiben;

  function tibUrlSync() {
    var sel = document.querySelector('select[name="id"], input[name="id"]');
    if (!sel || !sel.value) return;
    // Nur IDs uebernehmen, die es wirklich als Option gibt - TeeInBlue setzt
    // zwischendurch fremde Werte.
    if (sel.tagName === 'SELECT' && !sel.querySelector('option[value="' + (/^\d+$/.test(sel.value) ? sel.value : '0') + '"]')) return;
    urlVarianteSchreiben(sel.value);
  }

  function init() {
    try {
      if (ctx.isTib) {
        var versuche = 0;
        var timer = setInterval(function () {
          versuche++;
          if (tibStart() || versuche > 60) clearInterval(timer);
        }, 400);
        // TeeInBlue rendert Felder nach; die Schrittliste bleibt so aktuell.
        setInterval(function () { try { tibBeobachten(); } catch (e) {} }, 2000);
        setInterval(tibUrlSync, 800);
        document.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'id') tibUrlSync();
        }, true);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
